import { render, staticRenderFns } from "./DonationCallback.vue?vue&type=template&id=235f9f16&scoped=true&"
import script from "./DonationCallback.vue?vue&type=script&lang=js&"
export * from "./DonationCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f9f16",
  null
  
)

export default component.exports